var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRetake = function SvgRetake(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "retake"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/refresh-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6668 8.00016C14.6668 11.6802 11.6802 14.6668 8.00016 14.6668C4.32016 14.6668 2.0735 10.9602 2.0735 10.9602M2.0735 10.9602H5.08683M2.0735 10.9602V14.2935M1.3335 8.00016C1.3335 4.32016 4.2935 1.3335 8.00016 1.3335C12.4468 1.3335 14.6668 5.04016 14.6668 5.04016M14.6668 5.04016V1.70683M14.6668 5.04016H11.7068",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRetake);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InJldGFrZSI+CjxnIGlkPSJ2dWVzYXgvbGluZWFyL3JlZnJlc2gtMiI+CjxnIGlkPSJyZWZyZXNoLTIiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTQuNjY2OCA4LjAwMDE2QzE0LjY2NjggMTEuNjgwMiAxMS42ODAyIDE0LjY2NjggOC4wMDAxNiAxNC42NjY4QzQuMzIwMTYgMTQuNjY2OCAyLjA3MzUgMTAuOTYwMiAyLjA3MzUgMTAuOTYwMk0yLjA3MzUgMTAuOTYwMkg1LjA4NjgzTTIuMDczNSAxMC45NjAyVjE0LjI5MzVNMS4zMzM1IDguMDAwMTZDMS4zMzM1IDQuMzIwMTYgNC4yOTM1IDEuMzMzNSA4LjAwMDE2IDEuMzMzNUMxMi40NDY4IDEuMzMzNSAxNC42NjY4IDUuMDQwMTYgMTQuNjY2OCA1LjA0MDE2TTE0LjY2NjggNS4wNDAxNlYxLjcwNjgzTTE0LjY2NjggNS4wNDAxNkgxMS43MDY4IiBzdHJva2U9IiM0MjM5RkIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8L2c+CjwvZz4KPC9zdmc+Cg==";